import React from 'react';
import { getLiftClass, getLiftColor } from "../../helpers/map";

const LiftM = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="LiftM" transform="translate(1394.758829, 959.600684)"
			 className={getLiftClass(isOpen, activeLiftId === 'M', state)}
		>
			<line
				x1="45.367788" y1="-9" x2="34.7690186" y2="37.2070596" id="Line-" stroke={colors[0]} strokeWidth="3"
				strokeLinecap="round" strokeDasharray="6"
				transform="translate(40.068403, 14.103530) rotate(76.000000) translate(-40.068403, -14.103530) "/>

			<g id="Labe-lift"
				 transform="translate(60.767697, 13.656250) rotate(1.000000) translate(-60.767697, -13.656250) translate(47.767697, 0.656250)">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
				<text fontFamily="OpenSans-Bold, Open Sans" fontSize="12" fontWeight="normal" fill={colors[2]}>
					<tspan x="6.84277344" y="17">M</tspan>
				</text>
			</g>

			<g id="Labe-lift" className="lift-label"
				 transform="rotate(1.000000) translate(1.000000, 1.158145)">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
			</g>

			<g
				transform="translate(14.078221, 14.570603) rotate(-2.000000) translate(-14.078221, -14.570603) translate(5.078221, 10.070603)"
				fill={colors[2]}
			>
				<polygon
					transform="translate(4.304348, 4.304348) scale(-1, 1) rotate(-180.000000) translate(-4.304348, -4.304348) "
					points="-8.68638494e-13 4.30434783 8.60869565 3.90798505e-14 6.7527491 4.30434783 8.60869565 8.60869565"/>
				<polygon
					transform="translate(13.695652, 4.304348) rotate(-180.000000) translate(-13.695652, -4.304348) "
					points="9.39130435 4.30434783 18 3.90798505e-14 16.1440534 4.30434783 18 8.60869565"/>
			</g>
		</g>
	);
};


LiftM.propTypes = {};

export default LiftM;
